import React, { useEffect, useState } from "react";
import {notifyError,exportUnsubscribersToCSV, notifySuccess} from '../../helper';
import { confirmAlert } from "react-confirm-alert"; // Import the library
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import UnsRow from "./UnsRow";
import BlockLoader from "../BlockLoader";
import "react-confirm-alert/src/react-confirm-alert.css";
import SubscribeDomainModelWindow from "../campaigns/models/SubscribeDomainModelWindow";

const Unsubscribers = () => {
    const api = client();
    const [unsubscribers,setUnsubscribers]= useState([]);
    const [pageLoader, setPageLoader] = useState(true);
    const [payload,setPayload] = useState({searchText: ""});
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [actionsDisplay,setActionsDisplay] = useState(false);
    const [count, setCount] = useState(0);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [exportLoader, setExportLoader] = useState(false);
    const [offset, setOffset] = useState(0); // For pagination
    const [limit] = useState(10); // Number of leads per request
    const [totalCount, setTotalCount] = useState(0); // Total leads available
    const [showModelWindow,setShowModelWindow] = useState(false);
    const [selectedRecipient, setSelectedRecipient] = useState({});

    const addCheckedStatus = (data) => {
        const updatedData = data.map((v,i)=>({...v,isChecked:false}));
        setUnsubscribers(updatedData);
    }

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setIsAllChecked(isChecked);
        const updatedItems = unsubscribers.map((v,i)=>({...v,isChecked:isChecked}));
        setUnsubscribers(updatedItems);
        setActionsDisplay(isChecked);
        setCount(updatedItems.filter(item => item.isChecked).length);
    }

    const handleCheckboxChange = (id) => {
        const updatedItems = unsubscribers.map(item =>
            item._id === id ? { ...item, isChecked: !item.isChecked } : item
          );
          setIsAllChecked(updatedItems.every(item => item.isChecked));
          setActionsDisplay(updatedItems.some(item => item.isChecked));
          setUnsubscribers(updatedItems);
          setCount(updatedItems.filter(item => item.isChecked).length);
    }

    const handleFilter = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;        
        setPayload({...payload,[inputName]:inputValue});
        setActionsDisplay(false);
        setIsAllChecked(false);
        setCount(0);
        setOffset(0); // Reset offset on filter change
        
    }

    const handleDownloadCSV = () => {
        exportUnsubscribersToCSV(unsubscribers.filter(item => item.isChecked),setExportLoader);
    }
    const handleUnsubscribersDelete = async () =>{
        const selectedEmailIds = unsubscribers.filter(item => item.isChecked).map(item => item.email);
        if(!selectedEmailIds.length){
            notifyError('Please select at least 1 unsubscribed email to delete');
        } else {
            try{
                setDeleteLoader(true);
                const response = await api.post('/v1/contact/unsubscribes/allDomains/delete',{
                    email_list:selectedEmailIds,                    
                });
                if(response.status === 200 || response.status === 201){
                    setDeleteLoader(false);
                    notifySuccess('Selected unsubscribes deleted');
                    setTimeout(()=>{
                        window.location.reload();
                    },1500);
                }
            } catch(error) {
                setDeleteLoader(false);
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to delete campaign(s). Please try again'); 
            }   
        } 
    }
    const getUnsubscribersData = async (append = false) => {
        setPageLoader(true);
        try{
            const response = await api.post('/v1/contact/unsubscribes', { ...payload, offset, limit });
            if(response.status === 200 || response.status === 201){
                const data = response.data.unsubscribesContacts;
                setTotalCount(response.data.total_count); // Update total unsubscribers count
                addCheckedStatus(append ? [...unsubscribers, ...data] : data); // Append data if needed
                setPageLoader(false);
            }

        } catch (error){
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to fetch Unsubscribers. Please try again.');
            setPageLoader(false);
        }
    };

    const handleLoadMore = () => {
        setOffset((prevOffset) => prevOffset + limit);
    };

    useEffect(() => {
        getUnsubscribersData(offset > 0); // Append data only if offset > 0
    }, [payload, offset]);


    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="unsubscribers-pages-wrap">
                {actionsDisplay ? <div className="action-wrap lead-action-wrap">
                    <div className="selected-records">
                        {count} selected
                    </div>
                    <div className="action-group">
                        <div className="field-wrap">
                            <button 
                                className={deleteLoader ? "delete-btn button--loading":"delete-btn"}
                                disabled={deleteLoader} 
                                onClick={()=>{
                                    confirmAlert({
                                        title: "Delete Unsubscribers...!",
                                        message: "Are you sure you want to delete the unsubscribers?",
                                        buttons: [
                                            { label: "Delete", onClick: () => {handleUnsubscribersDelete()} },
                                            { label: "Cancel", onClick: () => {console.log('Delete action canceled..!')}}
                                        ]
                                    })
                                }}><span className="button--text">Delete</span></button>
                        </div>
                        
                        <div className="field-wrap">
                            <button 
                                className={exportLoader ? "export-btn button--loading":"export-btn"}
                                disabled={exportLoader}
                                onClick={handleDownloadCSV}><span className="button--text">Export</span></button>
                        </div>
                    </div>
                </div>:<div className="top-section"><h1>Unsubscribers</h1></div>}
                <div className="unsubscribers-wrap">
                    <div className="unsubscribers">
                        

                        <div className="unsubscribers-data-block">
                            <div className="unsubscribers-filter">
                                <div className="field-wrap">
                                    <input 
                                        type="text" 
                                        name="searchText" 
                                        value={payload.searchText} 
                                        placeholder="Search"  
                                        onChange={handleFilter}
                                        />
                                </div>
                                
                            </div>

                            {pageLoader ? <div className="block-loader" style={{minHeight:'550px', width:'100%',background:'#fff'}}><BlockLoader /></div> :<table>
                                <thead>
                                    <tr>
                                        <th>
                                            <input 
                                                type="checkbox" 
                                                disabled={!unsubscribers.length}
                                                checked={unsubscribers.length && isAllChecked} 
                                                name="select-all" 
                                                onChange={handleSelectAll} 
                                            />
                                        </th>
                                        <th>Email</th>
                                        <th>Unsubscribe Date</th>
                                        <th>Domains</th>
                                        <th className="align-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unsubscribers.length ? unsubscribers.map((row,i)=>(<UnsRow 
                                        row={row} 
                                        key={i} 
                                        handleCheckboxChange={handleCheckboxChange} 
                                        showModelWindow = {showModelWindow}
                                        setShowModelWindow = {setShowModelWindow}
                                        setSelectedRecipient={setSelectedRecipient}
                                        />
                                    )):<tr>
                                        <td colSpan={3}>Unsubscribers data not available.</td>
                                    </tr>}
                                </tbody>
                            </table>}
                            <div className="more-records">
                                {unsubscribers.length < totalCount && (
                                    <button onClick={handleLoadMore}>
                                        <i className="bx bx-chevron-down"></i>
                                    </button>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        {showModelWindow && <SubscribeDomainModelWindow 
            showModelWindow = {showModelWindow}
            setShowModelWindow = {setShowModelWindow}
            selectedRecipient = {selectedRecipient}             
        />}
        <Footer/>
    </>);
}

export default Unsubscribers;
